<template>
  <div :class="['layer-popup-wrap', isOpen ? 'open' : '']">
    <div class="layer-popup" tabindex="0">
      <h4 class="pop-tit">Open API</h4>
      <div class="pop-cont">
        <table class="pop-table">
          <caption>Open API</caption>
          <colgroup>
            <col class="res-col">
            <col>
          </colgroup>
          <tbody>
          <tr>
            <th>데이터 포멧</th>
            <td>JSON</td>
          </tr>
          <tr :style="[mdss ? {'display':''} : {'display':'none'}]">
            <th>조회 조건</th>
            <td>{{ mdssNavi }}</td>
          </tr>
          <tr :style="[mdss ? {'display':''} : {'display':'none'}]">
            <th>받을 정보</th>
            <td>
              <span class="inp-pop">
                <label><input type="radio" name="recvInfo" v-model="recvInfo" value="A"> MDSS 항목</label>
              </span>
              <span class="inp-pop" style="padding-left: 10px;">
                <label><input type="radio" name="recvInfo" v-model="recvInfo" value="D"> MDSS 데이터</label>
              </span>
            </td>
          </tr>
          <tr style="display: none">
            <th>조회기간</th>
            <td>
              <div class="srh-date">
                <div class="date-box">
                  최근 시점 부터
                  <select v-model="selectedTerm" title="최근 시점 선택">
                    <option v-for="data in recentYears" :value="data.value">{{ data.text }}</option>
                  </select>
                </div>
                <div class="date-box">
                  시점
                  <select v-model="selectedFromYear" title="시점 시작 년도 선택">
                    <span>{{ selectedFromYear }}</span>
                    <option v-for="data in fromYears" :value="data.value">{{ data.text }}</option>
                  </select> ~
                  <select v-model="selectedToYear" title="시점 종료 년도 선택">
                    <span>{{ selectedToYear }}</span>
                    <option v-for="data in toYears" :value="data.value">{{ data.text }}</option>
                  </select>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th>소속</th>
            <td><input type="text" class="inp-field" title="소속을 입력해주세요." ref="orgInput" placeholder="소속을 입력해주세요." v-model="organization"></td>
          </tr>
          <tr>
            <th>사용목적</th>
            <td><input type="text" class="inp-field" title="사용목적을 간단히 입력해주세요." ref="purInput" placeholder="사용목적을 간단히 입력해주세요." v-model="purpose"></td>
          </tr>
          </tbody>
        </table>
        <div class="btn-right-box">
          <button type="button" class="btn-fnc" @click="createUrl">URL 생성</button>
        </div>
        <div class="url-area">
          <div class="url-txt">{{ apiUrl }}</div>
          <div class="pop-btn-box align-r">
            <button type="button" class="pop-btn bg-blue" @click="copyUrl">URL 복사</button>
            <button type="button" class="pop-btn line-white" @click="goManual">Open API 매뉴얼</button>
          </div>
        </div>
      </div>
      <button type="button" class="btn-pop-close" @click="close"><span class="hidden">닫기</span></button>
    </div>
  </div>
</template>

<script>
import * as staticApi from '@/api/Statistics.js'
import {getStatsInfo, issueValidateKey} from "@/api/open-api";

export default {
  name: "OpenApiPopup",
  props: {
    type: {
      type: String,
      default: 'subject' //subject: 주제별통계, index: 지표통계
    },

    mdss: {
      type: Boolean,
      default: false
    },

    statId: {
      type: String
    }
  },
  data() {
    return {
      recentYears: [],
      fromYears: [],
      toYears: [],
      thisYear: 0,
      isOpen: false,
      selectedTerm: 0,
      selectedFromYear: 0,
      selectedToYear: 0,
      organization: '',
      purpose: '',
      apiUrl: '',
      statYr: '',
      mdssNavi: '',
      recvInfo: 'A',
      popBtn: ''
    }
  },

  watch: {
    selectedTerm: {
      immediate: true,
      handler: function(value) {
        this.selectedFromYear = this.thisYear;
        this.selectedToYear = this.thisYear - value;
      }
    }
  },

  methods: {
    reset() {
      this.term = 10;

      const recentYears = [];
      const fromYears = [];
      const toYears = [];

      this.thisYear = new Date().getFullYear();
      new Array(this.term).fill('').forEach((item, index) => {
        recentYears.push({text: `${index + 1}년`, value: index + 1});
        fromYears.push({text: `${this.thisYear - index}년`, value: this.thisYear - index});
        toYears.push({text: `${this.thisYear - index - 1}년`, value: this.thisYear - index - 1});
      });

      this.recentYears.splice(0, this.recentYears.length, ...recentYears);
      this.fromYears.splice(0, this.fromYears.length, ...fromYears);
      this.toYears.splice(0, this.toYears.length, ...toYears);
      this.selectedTerm = recentYears.at().value;
      this.organization = '';
      this.purpose = '';
      this.apiUrl = '';
      this.recvInfo = 'A';

      // mdss 일 때
      if (this.mdss)
        this.getTreeFormalityDataList();
    },

    open(evt) {
      this.reset();
      this.isOpen = true;
      document.body.style.overflow = 'hidden';

      // 웹접근성 레이어 팝업 키보드 초점
      this.popBtn = evt.target
      setTimeout(() => {
        const popup = this.$parent.$refs.apiPopup.$el
        popup.firstChild.focus()
      }, 300);
    },

    close() {
      this.$nextTick(() => {
        this.isOpen = false;
        document.body.style.overflow = '';
      });

      // 웹접근성 레이어 팝업 키보드 초점
      this.popBtn.focus()
    },

    createUrl() {
      // mdss 일 때
      if (this.mdss) {
        if (this.recvInfo === '') {
          return alert('받을 정보를 선택하세요.');
        }
      }

      // if (this.organization === '' || this.purpose === '') {
      //   return alert('소속과 사용목적을 입력하세요.');
      // }

      // 웹접근성 개선 수정 - alert창 메세지 2개로(소속,사용목적) 분리
      if (this.organization === '') {
        this.$refs.orgInput.focus();
        return alert('소속을 입력하세요.');
      }

      if (this.purpose === '') {
        this.$refs.purInput.focus();
        return alert('사용목적을 입력하세요.');
      }

      issueValidateKey(this.organization, this.purpose).then(result => {
        const validateKey = result.data;

        // mdss 일 때
        if (this.mdss) {
          if (this.recvInfo == 'A') {
            this.apiUrl = `${process.env.VUE_APP_SERVER}/openapi/mdss/getArtclList?statsId=${this.statId}&statsYr=${this.statYr}&ctfcnVl=${validateKey}`;
          } else if (this.recvInfo == 'D') {
            this.apiUrl = `${process.env.VUE_APP_SERVER}/openapi/mdss/getDataList?statsId=${this.statId}&statsYr=${this.statYr}&ctfcnVl=${validateKey}`;
          }
        } else {
          const statsType = this.type === 'subject' ? '01' : '02';
          this.apiUrl = `${process.env.VUE_APP_SERVER}/openapi/stats/getStatsInfo?statsType=${statsType}&statsMngNo=${this.statId}&ctfcnVl=${validateKey}`;
        }

        return this.apiUrl;
      }).then(apiUrl => {
        return getStatsInfo(apiUrl)
      }).then(result => {
        //INFO code in here
      })
    },

    copyUrl() {
      window.navigator.clipboard.writeText(this.apiUrl);
      alert('URL 복사 완료');
    },

    goManual() {
      if (this.mdss)
        window.open(`${window.location.origin}/portal/notice/MdssOpenApi`, '_blank');
      else
        window.open(`${window.location.origin}/portal/notice/StatsOpenApi`, '_blank');
    },

    /**
     * 조회 조건 텍스트
     */
    async getTreeFormalityDataList () {
      const paramData = {
        anlClsId: this.statId
      }
      const res = await staticApi.selectTreeFormalityDataList(paramData)

      let mdssNavi = '';

      if (res.data.length > 0) {
        res.data.forEach((row, idx) => {
          if (row.anlClsId == this.statId) {
            this.statYr = row.anlClsNm;
          }

          if (idx == res.data.length-1) {
            mdssNavi += row.anlClsNm;
          } else {
            mdssNavi += row.anlClsNm + " > ";
          }
        });
      }

      this.mdssNavi = mdssNavi
    }

  },

}
</script>
